module.exports = __webpack_public_path__ + "img/top_banner2.fe26ca08.png";